var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgCloseX({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 15,
    height: 15,
    viewBox: "0 0 15 15",
    fill: "currentColor",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M9.28139 7.5003L14.6254 12.8443C15.1249 13.3438 15.1249 14.1262 14.6254 14.6257C14.1259 15.1252 13.3435 15.1252 12.844 14.6257L7.5 9.28139L2.156 14.6254C1.65653 15.1249 0.874071 15.1249 0.374602 14.6254C-0.124867 14.1259 -0.124867 13.3435 0.374602 12.844L5.71861 7.5L0.374602 2.156C-0.124867 1.65653 -0.124867 0.874071 0.374602 0.374602C0.874071 -0.124867 1.65653 -0.124867 2.156 0.374602L7.5 5.71861L12.8437 0.374602C13.3432 -0.124867 14.1256 -0.124867 14.6251 0.374602C15.1246 0.874071 15.1246 1.65653 14.6251 2.156L9.28139 7.5003Z",
    fill: "currentColor"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCloseX);
export default __webpack_public_path__ + "static/media/closeX.9d0423dc242044e2aaefa103dd76e7b0.svg";
export { ForwardRef as ReactComponent };